import { render } from "./LogOutView.vue?vue&type=template&id=2c5cd88c"
import script from "./LogOutView.vue?vue&type=script&lang=js"
export * from "./LogOutView.vue?vue&type=script&lang=js"

import "./LogOutView.vue?vue&type=style&index=0&id=2c5cd88c&lang=css"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__